import { useEffect, useState } from 'react';

export function hasActiveTeamBranding(team, now = Date.now()) {
  if (team?.branding_enabled !== true) return false;
  const expiresAt = Date.parse(team.subscription_expires_at);
  const startsAt = team.subscription_starts_at == null ? null : Date.parse(team.subscription_starts_at);
  return Number.isFinite(expiresAt) && expiresAt > now
    && (startsAt === null || (Number.isFinite(startsAt) && startsAt <= now));
}

// Expiry must restore the platform brand even while the same page stays open.
export function useActiveTeamBranding(team) {
  const [checkedAt, setCheckedAt] = useState(Date.now);
  const expiresAt = Date.parse(team?.subscription_expires_at);
  useEffect(() => {
    const check = () => setCheckedAt(Date.now());
    const remaining = expiresAt - Date.now();
    const timer = Number.isFinite(remaining) && remaining > 0
      ? window.setTimeout(check, Math.min(remaining + 1, 2147483647)) : null;
    window.addEventListener('focus', check);
    document.addEventListener('visibilitychange', check);
    return () => {
      window.clearTimeout(timer);
      window.removeEventListener('focus', check);
      document.removeEventListener('visibilitychange', check);
    };
  }, [checkedAt, expiresAt]);
  return hasActiveTeamBranding(team);
}
